// Simple server-side obfuscation - NOT true encryption
// This just prevents reading messages directly in the database
// but does not provide E2E security

const OBFUSCATION_KEY = 'lovable_chat_obfuscation_2024';

// Simple XOR-based obfuscation with base64 encoding
export function obfuscateMessage(message: string): string {
  try {
    const encoder = new TextEncoder();
    const messageBytes = encoder.encode(message);
    const keyBytes = encoder.encode(OBFUSCATION_KEY);
    
    const obfuscated = new Uint8Array(messageBytes.length);
    for (let i = 0; i < messageBytes.length; i++) {
      obfuscated[i] = messageBytes[i] ^ keyBytes[i % keyBytes.length];
    }
    
    // Add prefix to identify obfuscated messages
    return 'OBF:' + btoa(String.fromCharCode(...obfuscated));
  } catch (error) {
    console.error('Obfuscation error:', error);
    return message;
  }
}

export function deobfuscateMessage(obfuscatedMessage: string): string {
  try {
    // Check if message is obfuscated
    if (!obfuscatedMessage.startsWith('OBF:')) {
      return obfuscatedMessage;
    }
    
    const base64Data = obfuscatedMessage.slice(4);
    const obfuscatedBytes = new Uint8Array(
      atob(base64Data).split('').map(c => c.charCodeAt(0))
    );
    const keyBytes = new TextEncoder().encode(OBFUSCATION_KEY);
    
    const deobfuscated = new Uint8Array(obfuscatedBytes.length);
    for (let i = 0; i < obfuscatedBytes.length; i++) {
      deobfuscated[i] = obfuscatedBytes[i] ^ keyBytes[i % keyBytes.length];
    }
    
    const decoder = new TextDecoder();
    return decoder.decode(deobfuscated);
  } catch (error) {
    console.error('Deobfuscation error:', error);
    return obfuscatedMessage;
  }
}

export function isObfuscatedMessage(text: string): boolean {
  return text.startsWith('OBF:');
}
